import type { WebConfig } from "~/hooks/webconfig";

/** Stage same-origin HTTP on s101; production awaits long-request edge validation. */
export function browserHttpGraphqlUrl(
  config: Pick<WebConfig, "environment" | "graphqlAPI">,
  location: Pick<Location, "protocol" | "hostname" | "port">,
): string {
  const domain =
    config.environment === "s101"
      ? // eslint-disable-next-line lingui/no-unlocalized-strings -- Deployment hostname, not user-facing text.
        "s101.mindstone.dev"
      : undefined;
  if (
    domain &&
    location.protocol === "https:" &&
    !location.port &&
    location.hostname.endsWith(`.${domain}`) &&
    (config.graphqlAPI === `https://graphql.${domain}/query` ||
      config.graphqlAPI === `https://app.${domain}/graphql`)
  ) {
    return "/graphql";
  }
  return config.graphqlAPI;
}
